export default "__VITE_ASSET__O$$alf7P__"